import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { Label } from 'rbx';
import { cloneDeep } from 'lodash';

import {
  CheckBox,
  InputAddOn,
  // Select
} from '../../../components/elements';
// import moment from 'moment';
// import { isNull } from 'lodash';
// import ReactTooltip from 'react-tooltip';

const IconStyled = styled.i`
  margin-right: 10px;
`;

const sellTypeValue = {
  ITEM: 'ITEM',
  MODIFIER: 'MODIFIER',
  DEAL: 'DEAL',
};

// const sellTypeEnum = [
//   { value: 'ITEM', label: 'ITEM' },
//   { value: 'MODIFIER', label: 'MODIFIER' },
//   { value: 'DEAL', label: 'DEAL' },
// ];

const CheckInList = ({ item, onItemValueChange }) => {
  const [itemValue, setItemValue] = React.useState();

  React.useEffect(() => {
    setItemValue(cloneDeep(item));
  }, [item]);

  const hasVariant =
    item?.variant &&
    Array.isArray(item?.variant) &&
    item?.variant[0] &&
    item?.variant[0].variants;

  const [isActive, setIsActive] = React.useState(true);

  if (!itemValue) {
    return <></>;
  }

  return (
    <>
      <tr>
        <td>
          <div className="is-flex flex-direction-row ">
            {hasVariant ? (
              <div onClick={() => setIsActive(!isActive)}>
                {isActive ? (
                  <IconStyled className="fas fa-chevron-down" />
                ) : (
                  <IconStyled className="fas fa-chevron-right" />
                )}
              </div>
            ) : (
              <div className="m-2" />
            )}
            <a
              href={`/update-menu-item/${item.menu_item_id}`}
              target="_blank"
              rel="noreferrer"
            >
              <span className="is-size-3">
                {item.name} {hasVariant && '+'}
              </span>
              <p>
                <span style={{ color: '#505050' }}>({item.internal_name})</span>
              </p>
            </a>
          </div>
        </td>
        <td>
          <InputAddOn
            addonsText="$"
            isLeft
            // label="Price"
            value={item.price ? `$${parseFloat(item.price).toFixed(2)}` : ' '}
            disabled
          />
        </td>
        <td>
          <InputAddOn
            addonsText="$"
            isLeft
            // label="New Price"
            value={!hasVariant ? itemValue.new_price || itemValue.price : '-'}
            // onFocus={() => {
            //   setEditing(true);
            // }}
            // onBlur={() => {
            //   setEditing(false);
            // }}
            onChange={e => {
              if (e.target.value < 0) {
                // eslint-disable-next-line no-alert
                alert('The input value must be greater than or equal to 0!');
                return;
              }

              const { value } = e.target;

              setItemValue(prev => {
                const temp = { ...prev };
                temp.price = value;
                temp.new_price = null;
                onItemValueChange({ itemValue: { ...temp, isSelected: true } });
                return temp;
              });
            }}
            disabled={hasVariant}
            disableToastMessage
            type="number"
            min="1"
          />
        </td>
        <td>
          <div className="is-flex mt-3">
            <CheckBox
              value={itemValue.popular}
              onChange={value => {
                setItemValue(prev => {
                  const temp = { ...prev };
                  temp.popular = value;
                  onItemValueChange({
                    itemValue: { ...temp, isSelected: true },
                  });
                  return temp;
                });
              }}
              disabled={
                !(
                  itemValue.selling_type === 'ITEM' ||
                  itemValue.selling_type === 'DEAL'
                )
              }
            />
            <Label>Popular Item</Label>
          </div>
        </td>
        <td>
          <div className="is-flex mt-3">
            <CheckBox
              value={itemValue.popular_addon}
              onChange={value => {
                setItemValue(prev => {
                  const temp = { ...prev };
                  temp.popular_addon = value;
                  onItemValueChange({
                    itemValue: { ...temp, isSelected: true },
                  });
                  return temp;
                });
              }}
              disabled={
                !(
                  itemValue.selling_type === 'ITEM' ||
                  itemValue.selling_type === 'DEAL'
                )
              }
            />
            <Label>Default Add-On</Label>
          </div>
        </td>
        <td>
          {sellTypeValue[itemValue.selling_type]}
          {/* <Select
            // label="Item Type(selling type)"
            value={{
              label: sellTypeValue[itemValue.selling_type],
              value: sellTypeValue[itemValue.selling_type],
            }}
            options={sellTypeEnum}
            onChange={value => {
              if (value.value === 'ITEM' || value.value === 'DEAL') {
                setItemValue(prev => {
                  const temp = { ...prev };
                  temp.sell_item_on_its_own = true;
                  temp.selling_type = value.value;
                  onItemValueChange({
                    itemValue: { ...temp, isSelected: true },
                  });

                  return temp;
                });
              } else {
                setItemValue(prev => {
                  const temp = { ...prev };
                  temp.sell_item_on_its_own = false;
                  temp.popular = false;
                  temp.popular_addon = false;
                  temp.selling_type = value.value;
                  onItemValueChange({
                    itemValue: { ...temp, isSelected: true },
                  });
                  return temp;
                });
              }
            }}
          /> */}
        </td>
      </tr>
      {isActive &&
        hasVariant &&
        item.variant[0].variants.map((ele, idx) => (
          <>
            <tr>
              <td>
                <p className="m-4">{ele.variant_name}</p>
              </td>
              <td>
                <InputAddOn
                  addonsText="$"
                  isLeft
                  label="Variant Price"
                  value={`$${parseFloat(ele.variant_price || 0).toFixed(2)}`}
                  disabled
                />
              </td>
              <td>
                <InputAddOn
                  addonsText="$"
                  isLeft
                  label="Variant New Price"
                  value={
                    itemValue.variant[0].variants[idx].new_variant_price ||
                    itemValue.variant[0].variants[idx].variant_price
                  }
                  onChange={e => {
                    if (e.target.value < 0) {
                      // eslint-disable-next-line no-alert
                      alert(
                        'The input value must be greater than or equal to 0!',
                      );
                      return;
                    }

                    const { value } = e.target;

                    setItemValue(prev => {
                      const temp = { ...prev };
                      temp.variant[0].variants[idx].variant_price = value;
                      temp.variant[0].variants[idx].new_variant_price = null;
                      onItemValueChange({
                        itemValue: { ...temp, isSelected: true },
                      });
                      return temp;
                    });
                  }}
                  disableToastMessage
                  type="number"
                  min="1"
                />
              </td>
              <td />
              <td />
              <td />
            </tr>
          </>
        ))}
    </>
  );
};

export default CheckInList;
